(() => {
  const $ = (selector, scope = document) => scope.querySelector(selector);
  const $$ = (selector, scope = document) => [...scope.querySelectorAll(selector)];
  const body = document.body;
  const live = $('#LiveRegion');
  const announce = (message) => { if (live) live.textContent = message; };

  const trapFocus = (container) => {
    const items = $$('a[href],button:not([disabled]),input:not([disabled]),select,textarea,[tabindex]:not([tabindex="-1"])', container);
    if (!items.length) return () => {};
    const first = items[0], last = items[items.length - 1];
    const handler = (event) => {
      if (event.key !== 'Tab') return;
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    };
    container.addEventListener('keydown', handler); first.focus();
    return () => container.removeEventListener('keydown', handler);
  };

  let releaseFocus = null;
  const drawer = $('#CartDrawer');
  const openDrawer = () => { if (!drawer) return; drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false'); body.classList.add('is-locked'); $('[data-cart-open]')?.setAttribute('aria-expanded', 'true'); releaseFocus = trapFocus($('.drawer__panel', drawer)); };
  const closeDrawer = () => { if (!drawer) return; drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true'); body.classList.remove('is-locked'); $('[data-cart-open]')?.setAttribute('aria-expanded', 'false'); releaseFocus?.(); $('[data-cart-open]')?.focus(); };
  $$('[data-cart-open]').forEach((button) => button.addEventListener('click', openDrawer));
  $$('[data-drawer-close]').forEach((button) => button.addEventListener('click', closeDrawer));

  const menu = $('#MobileMenu');
  const openMenu = () => { menu?.classList.add('is-open'); menu?.setAttribute('aria-hidden', 'false'); body.classList.add('is-locked'); $('[data-menu-open]')?.setAttribute('aria-expanded', 'true'); if (menu) releaseFocus = trapFocus(menu); };
  const closeMenu = () => { menu?.classList.remove('is-open'); menu?.setAttribute('aria-hidden', 'true'); body.classList.remove('is-locked'); $('[data-menu-open]')?.setAttribute('aria-expanded', 'false'); releaseFocus?.(); };
  $('[data-menu-open]')?.addEventListener('click', openMenu); $('[data-menu-close]')?.addEventListener('click', closeMenu);
  document.addEventListener('keydown', (event) => { if (event.key === 'Escape') { closeDrawer(); closeMenu(); } });

  const updateCartDrawer = async () => {
    const response = await fetch(`${window.Shopify?.routes?.root || '/'}?sections=cart-drawer`);
    const sections = await response.json();
    const parsed = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
    const fresh = $('#CartDrawer', parsed);
    if (fresh && drawer) drawer.innerHTML = fresh.innerHTML;
    const cart = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`).then((r) => r.json());
    $$('[data-cart-count]').forEach((count) => count.textContent = cart.item_count);
  };

  const changeLine = async (line, quantity, key = '') => {
    const root = window.Shopify?.routes?.root || '/';
    const cart = await fetch(`${root}cart.js`).then((response) => response.json());
    const target = key ? cart.items.find((item) => item.key === key) : cart.items[line - 1];
    const pairId = target?.properties?._sinch_pair_id;
    if (pairId && !target?.properties?._sinch_chain_addon) {
      const updates = {};
      cart.items.filter((item) => item.properties?._sinch_pair_id === pairId).forEach((item) => { updates[item.key] = quantity; });
      await fetch(`${root}cart/update.js`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates }) });
    } else {
      await fetch(`${root}cart/change.js`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: target?.key || line, quantity }) });
    }
    await updateCartDrawer(); openDrawer();
  };
  drawer?.addEventListener('click', (event) => {
    if (event.target.closest('[data-drawer-close]')) { closeDrawer(); return; }
    const item = event.target.closest('[data-line]'); if (!item) return;
    const input = $('input', item); const line = Number(item.dataset.line); const key = item.dataset.key || ''; const value = Number(input.value);
    if (event.target.closest('[data-remove-line]')) { changeLine(line, 0, key); return; }
    if (event.target.closest('[data-quantity-minus]')) changeLine(line, Math.max(0, value - 1), key);
    if (event.target.closest('[data-quantity-plus]')) changeLine(line, value + 1);
  });

  // Removes a cart line (and, when the removed line is a paired bag, cascades to
  // remove its linked "Supplément chaîne" addon via changeLine's pairId cascade).
  // On the standalone /cart page the AJAX update only refreshes the drawer, so the
  // page itself is reloaded afterwards to reflect the removal in the server-rendered list.
  document.addEventListener('click', (event) => {
    const remove = event.target.closest('[data-cart-remove]');
    if (!remove) return;
    event.preventDefault();
    const onCartPage = window.location.pathname.replace(/\/$/, '').endsWith('/cart');
    changeLine(Number(remove.dataset.line || 1), 0, remove.dataset.key || '').then(() => {
      if (onCartPage) window.location.reload();
    });
  });


  // Removes only the paid chain addon line while keeping the paired bag, clearing the
  // bag's own "Chaîne" properties so it no longer displays or re-implies a paid chain.
  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-chain-addon-remove]');
    if (!button) return;
    event.preventDefault();
    button.disabled = true;
    try {
      const root = window.Shopify?.routes?.root || '/';
      const addonKey = button.dataset.addonKey || '';
      const cart = await fetch(`${root}cart.js`).then((response) => response.json());
      const addon = cart.items.find((item) => item.key === addonKey);
      const pairId = addon?.properties?._sinch_pair_id || '';
      const bag = cart.items.find((item) => item.properties?._sinch_pair_id === pairId && !item.properties?._sinch_chain_addon);
      if (bag) {
        const properties = { ...bag.properties };
        delete properties['Chaîne'];
        delete properties['Chaîne choisie'];
        await fetch(`${root}cart/change.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: bag.key, quantity: bag.quantity, properties })
        });
      }
      await fetch(`${root}cart/change.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: addonKey, quantity: 0 })
      });
      if (window.location.pathname.replace(/\/$/, '').endsWith('/cart')) {
        window.location.reload();
      } else {
        await updateCartDrawer();
        openDrawer();
      }
    } catch (error) {
      button.disabled = false;
      console.error('Impossible de retirer le supplément chaîne', error);
    }
  });

  $$('[data-product-section]').forEach((section) => {
    const form = $('[data-product-form]', section); if (!form) return;
    const variants = JSON.parse($('[data-product-json]', section)?.textContent || '[]');
    const idInput = $('[data-variant-id]', form); const submit = $('.product-form__submit', form); const addLabel = $('[data-add-label]', form);
    const formError = $('[data-product-error]', form);
    const selectVariant = () => {
      const optionInputs = $$('[data-option-position]', form);
      const requiresColorChoice = !!$('[data-color-choice="bag"]', form);
      let variant;
      if (optionInputs.length) {
        const selected = optionInputs.filter((input) => input.checked).map((input) => input.value);
        variant = variants.find((item) => item.options.every((option, index) => option === selected[index]));
      } else if (!requiresColorChoice || variants.length === 1) {
        // Personalization uses line-item properties; a sole variant needs no option inputs.
        variant = variants[0];
      }
      if (!variant) { submit.disabled = true; addLabel.textContent = 'Combinaison indisponible'; return null; }
      idInput.value = String(variant.id); idInput.setAttribute('value', String(variant.id)); submit.disabled = !variant.available;
      addLabel.textContent = variant.available ? `Ajouter au panier — ${formatMoney(variant.price + ($("[data-chain-addon]:checked", form) ? Number($("[data-chain-options]", form)?.dataset.chainPrice || 0) : 0))}` : 'Épuisé';
      const promoEstimate = $('[data-promo-estimate]', form);
      if (promoEstimate) {
        const chainPrice = $('[data-chain-addon]:checked', form) ? Number($('[data-chain-options]', form)?.dataset.chainPrice || 0) : 0;
        const discountedTotal = Math.round(variant.price * 0.9) + Math.round(chainPrice * 0.9);
        promoEstimate.textContent = variant.available ? 'Avec le code SINCH10 : ' + formatMoney(discountedTotal) + ' — une utilisation par client, hors livraison. Remise appliquée au paiement.' : '';
      }
      if (variant.featured_media) $(`[data-media-target="${variant.featured_media.id}"]`, section)?.click();
      const url = new URL(location.href); url.searchParams.set('variant', variant.id); history.replaceState({}, '', url);
      return variant;
    };
    $$('[data-option-position]', form).forEach((input) => input.addEventListener('change', () => { input.closest('fieldset').querySelector('[data-option-value]').textContent = input.value; selectVariant(); }));
    selectVariant();

    // Chain upsell — "Sans chaîne" must never add the paid "Supplément chaîne" product.
    // Some browsers (bfcache / form-state restoration on back-forward navigation) can
    // silently re-check a previously selected paid chain option even though the freshly
    // rendered HTML marks "Sans chaîne" as checked, so force the no-chain default
    // explicitly on init and again whenever the page is restored from history.
    const chainFieldset = $('[data-chain-options]', form);
    const chainRadios = chainFieldset ? $$('input[name="properties[Chaîne]"]', chainFieldset) : [];
    chainRadios.forEach((input) => input.addEventListener('change', selectVariant));
    const noChainRadio = chainRadios.find((input) => !input.hasAttribute('data-chain-addon'));
    const resetChainSelection = () => { chainRadios.forEach((input) => { input.checked = input === noChainRadio; }); selectVariant(); };
    if (noChainRadio) {
      resetChainSelection();
      window.addEventListener('pageshow', (event) => { if (event.persisted) resetChainSelection(); });
    }
    const showProductError = (message) => {
      if (!formError) return;
      formError.textContent = message;
      formError.hidden = false;
    };
    const clearProductError = () => {
      if (!formError) return;
      formError.textContent = '';
      formError.hidden = true;
    };
    submit.addEventListener('click', () => {
      if (!$('[data-color-choice="bag"]:checked', form)) {
        showProductError('Choisissez votre couleur principale avant d’ajouter le sac au panier.');
      }
    });
    form.addEventListener('invalid', (event) => {
      if (event.target.matches?.('[data-color-choice="bag"]')) {
        showProductError('Choisissez votre couleur principale avant d’ajouter le sac au panier.');
      }
    }, true);
    const secondColorToggle = $('[data-second-color-toggle]', form);
    const secondColorPanel = $('[data-second-colors]', form);
    const previewPrimary = $('[data-preview-primary]', form);
    const previewSecondary = $('[data-preview-secondary]', form);
    const previewLabel = $('[data-preview-label]', form);
    const updatePreviewLabel = () => {
      if (!previewLabel) return;
      const bagName = $('[data-bag-color-name]', form)?.textContent;
      const secondName = $('[data-second-color-name]', form)?.textContent;
      if (bagName && secondName) previewLabel.textContent = `${bagName} & ${secondName}`;
      else if (bagName) previewLabel.textContent = bagName;
      else previewLabel.textContent = 'Choisissez une couleur ci-dessous';
    };
    const syncSecondColor = () => {
      if (!secondColorToggle || !secondColorPanel) return;
      const enabled = secondColorToggle.checked;
      secondColorPanel.hidden = !enabled;
      secondColorPanel.disabled = !enabled;
      $$('[data-color-choice="second"]', secondColorPanel).forEach((input) => {
        if (!input.closest('.is-sold-out')) input.required = enabled;
        if (!enabled) input.checked = false;
      });
      if (!enabled) {
        $('[data-second-color-name]', form).textContent = '';
        if (previewSecondary) { previewSecondary.hidden = true; previewSecondary.style.background = ''; }
        updatePreviewLabel();
      }
    };
    secondColorToggle?.addEventListener('change', syncSecondColor);
    syncSecondColor();
    $$('[data-color-choice]', form).forEach((input) => input.addEventListener('change', () => {
      if (input.dataset.colorChoice === 'bag') clearProductError();
      const isBag = input.dataset.colorChoice === 'bag';
      const target = isBag ? '[data-bag-color-name]' : '[data-second-color-name]';
      $(target, form).textContent = input.value;
      const swatchColor = input.closest('.swatch-choice')?.style.getPropertyValue('--swatch');
      const previewEl = isBag ? previewPrimary : previewSecondary;
      if (previewEl && swatchColor) {
        previewEl.style.background = swatchColor.trim();
        previewEl.hidden = false;
      }
      updatePreviewLabel();
    }));
    $$('[data-media-target]', section).forEach((button) => button.addEventListener('click', () => { $$('.product-media', section).forEach((media) => media.classList.toggle('is-active', media.dataset.mediaId === button.dataset.mediaTarget)); $$('.product-thumb', section).forEach((thumb) => thumb.classList.toggle('is-active', thumb === button)); $(`#Media-${section.dataset.sectionId}-${button.dataset.mediaTarget}`, section)?.scrollIntoView({ behavior: 'smooth', block: 'nearest' }); }));
    form.addEventListener('submit', async (event) => {
      event.preventDefault(); submit.classList.add('is-loading'); submit.disabled = true;
      try {
        clearProductError();
        const selectedVariant = selectVariant();
        if (!selectedVariant) throw new Error('Cette variante est momentanément indisponible.');
        const formData = new FormData(form);
        const properties = {};
        formData.forEach((value, key) => {
          const match = key.match(/^properties\[(.+)\]$/);
          if (match && value) properties[match[1]] = value;
        });
        const quantity = Math.max(1, Number(formData.get('quantity') || 1));
        const pairId = globalThis.crypto?.randomUUID?.() || `sinch-${Date.now()}-${Math.random().toString(36).slice(2)}`;
        properties._sinch_pair_id = pairId;
        const items = [{ id: String(selectedVariant.id), quantity, properties }];
        const paidChain = $('[data-chain-addon]:checked', form);
        const chainVariantId = $('[data-chain-options]', form)?.dataset.chainVariantId;
        const chainExplicitlyNone = !!(noChainRadio && noChainRadio.checked);
        if (paidChain && !paidChain.disabled && chainVariantId && !chainExplicitlyNone) {
          items.push({ id: Number(chainVariantId), quantity, properties: { '_Supplément pour': document.querySelector('h1')?.textContent?.trim() || 'Sac SINCH', '_sinch_pair_id': pairId, '_sinch_chain_addon': 'true', 'Chaîne choisie': paidChain.value } });
        }
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, { method: 'POST', headers: { Accept: 'application/json', 'Content-Type': 'application/json' }, body: JSON.stringify({ items }) });
        if (!response.ok) throw await response.json();
        await updateCartDrawer(); announce('Produit ajouté au panier'); openDrawer();
      }
      catch (error) { const message = error.description || error.message || 'Une erreur est survenue.'; announce(message); showProductError(message); addLabel.textContent = message; }
      finally { submit.classList.remove('is-loading'); submit.disabled = false; }
    });
  });

  function formatMoney(cents) { try { return new Intl.NumberFormat(document.documentElement.lang || 'fr-FR', { style: 'currency', currency: window.Shopify?.currency?.active || 'EUR' }).format(cents / 100); } catch { return `${(cents / 100).toFixed(2)} €`; } }
  document.addEventListener('click', (event) => { const wrapper = event.target.closest('.quantity'); if (!wrapper || wrapper.closest('[data-line]')) return; const input = $('input', wrapper); if (event.target.closest('[data-quantity-minus]')) input.value = Math.max(Number(input.min || 1), Number(input.value) - 1); if (event.target.closest('[data-quantity-plus]')) input.value = Number(input.value) + 1; });
  $('[data-sort-by]')?.addEventListener('change', (event) => { const url = new URL(location.href); url.searchParams.set('sort_by', event.target.value); location.href = url.toString(); });

  class ProductRecommendations extends HTMLElement { connectedCallback() { const observer = new IntersectionObserver((entries, obs) => { if (!entries[0].isIntersecting) return; obs.unobserve(this); fetch(this.dataset.url).then((response) => response.text()).then((text) => { const html = new DOMParser().parseFromString(text, 'text/html').querySelector('product-recommendations'); if (html?.innerHTML.trim()) this.innerHTML = html.innerHTML; }).catch(() => {}); }, { rootMargin: '300px' }); observer.observe(this); } }
  if (!customElements.get('product-recommendations')) customElements.define('product-recommendations', ProductRecommendations);
})();

(() => {
  const cache = new Map();
  document.querySelectorAll('[data-live-colors]').forEach(async (preview) => {
    try {
      const url = preview.dataset.liveColors;
      if (!cache.has(url)) cache.set(url, fetch(url).then(r => { if (!r.ok) throw new Error('Colors'); return r.text(); }));
      const doc = new DOMParser().parseFromString(await cache.get(url), 'text/html');
      const colors = [...doc.querySelectorAll('[data-primary-colors] input[data-color-choice="bag"]:not(:disabled)')];
      if (!colors.length) return;
      preview.replaceChildren();
      colors.slice(0, 3).forEach(input => {
        const dot = document.createElement('span');
        dot.className = 'model-card__color-dot';
        dot.style.background = input.closest('.swatch-choice').style.getPropertyValue('--swatch');
        dot.title = input.value;
        preview.append(dot);
      });
      if (colors.length > 3) {
        const more = document.createElement('span');
        more.className = 'model-card__color-more';
        more.textContent = '+' + (colors.length - 3);
        more.setAttribute('aria-hidden', 'true');
        preview.append(more);
      }
      preview.setAttribute('aria-label', colors.length + ' couleurs disponibles');
      preview.hidden = false;
    } catch {}
  });
})();
